import React, { Component } from 'react';

import Thanks from '../../../components/Thanks';
import Head from 'next/head';
import { Input, Textarea } from '../../../components/forms/input';

import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = '6Le-UtseAAAAAGpB4ucUJNIvZslgvZXc77lRT3tG';

class Offer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      title: props.ti,
      titleService: null,
      show: props.show,
      nda: 'No',
    };
    this.reRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);

    this.hideThanksModal = this.hideThanksModal.bind(this);
  }

  handleChange(param, value) {
    if (param == 'nda') {
      this.setState({ nda: value });
    }
    if (param == 'service') {
      let checkboxes = document.getElementsByName('service');
      let checkboxesChecked = [];

      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          checkboxesChecked.push(checkboxes[i]);
        }
      }
      if (checkboxesChecked.length > 1) {
        this.setState({ titleService: 'Digital Services' });
      } else {
        this.setState({ titleService: null });
      }
    }
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({ showModal: false, titleService: null, showThanks: false, loadedThanks: false });
    document.body.style.overflow = 'auto';

    document.body.style.overflowX = 'hidden';
  }
  onSubmit(e) {
    e.preventDefault();
    const token = this.reRef.current.getValue();

    if (token) {
      var that = this;

      var form_data = new FormData(e.target);

      for (var key in this.state.formdata) {
        form_data.append(key, this.state.formdata[key]);
      }

      if (this.state.titleService) form_data.append('title', this.state.titleService);
      else form_data.append('title', this.state.formdata.service);

      form_data.append('country', this.props.country);

      // that.setState({showThanks:true});

      document.body.style.overflow = 'hidden';

      axios.post('https://mailer.weprodigi.com/api/v1/video-production', form_data).then(response => {
        // that.setState({loadedThanks:true});
        window.location.href = 'https://weprodigi.com/thank-you';
      });
      // e.target.reset()
    }
  }
  hide = () => {
    this.setState({ showModal: false, titleService: null, showThanks: false, loadedThanks: false });
    document.getElementById('offer-form').reset();
    this.props.hide();
  };
  render() {
    return (
      <>
        <Head>
          <title>Marketing Services in Armenia- Get a Proposal | Prodigi</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/proposals/get-a-proposal" />
          <meta
            name="description"
            content="Request a proposal from Prodigi for customized digital services. Get a strategic plan designed to meet your goals."
          />
          <meta property="og:url" content="https://weprodigi.com/proposals/get-a-proposal" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Marketing Services in Armenia- Get a Proposal | Prodigi" />
          <meta
            property="og:description"
            content="Request a proposal from Prodigi for customized digital services. Get a strategic plan designed to meet your goals."
          />
        </Head>
        <div className="py-23 px-20 bg-gray-light">
          <h1 className="text-purple uppercase text-30 text-center font-black leading-none">Get a proposal</h1>
          {/* <p className="text-black uppercase text-18 text-center  font-black leading-none mt-15">Digital Services</p> */}

          <form id={!this.props.id ? 'offer-form' : 'form-offer'} method="POST" onSubmit={e => this.onSubmit(e)}>
            <div className="mt-10">
              <div className="mb-10">
                <p className="text-16 text-purple font-medium mb-10">1. Which services are you more interested in?</p>
                <div className="flex flex-wrap">
                  <div className="form-group mr-5  ml-10">
                    <label className="relative pl-30 mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0 bg-white"
                        onChange={() => this.handleChange('service', 'Video Production')}
                        type="checkbox"
                        name="service"
                        value="Video Production"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Video Production
                    </label>
                    <label className="relative pl-30  mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('service', 'Social Media Marketing')}
                        type="checkbox"
                        name="service"
                        value="Social Media Marketing"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Social Media Marketing
                    </label>
                  </div>
                  <div className="form-group mr-5  ml-10">
                    <label className="relative pl-30 mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('service', 'Paid advertisement')}
                        type="checkbox"
                        name="service"
                        value="Paid Advertising Services"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Paid Advertising Services
                    </label>
                    <label className="relative pl-30  mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('service', 'Development')}
                        type="checkbox"
                        name="service"
                        value="Website Development"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Website Development
                    </label>
                    <label className="relative pl-30 mt-10 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('service', 'SEO')}
                        type="checkbox"
                        name="service"
                        value="SEO"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      SEO
                    </label>
                  </div>
                  <div className="form-group mr-5  ml-10"></div>
                </div>

                <p className=" ml-10 text-14 text-black mb-5 mt-20">Does your company have a website?*</p>

                <div className="flex flex-row my-10 ml-10">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('has-website', 'Yes')}
                        type="radio"
                        name="has-website"
                        value="Yes"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Yes
                    </label>
                  </div>

                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('has-website', 'No')}
                        type="radio"
                        name="has-website"
                        value="No"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      No
                    </label>
                  </div>
                </div>

                {this.state.formdata['has-website'] == 'Yes' && (
                  <div>
                    <p className="text-14 text-black mb-5">Website URL*</p>

                    <div className="mb-10">
                      <Input type="text" name="website" bg="bg-white" required={true} onChange={this.handleChange} />
                    </div>
                  </div>
                )}
              </div>

              <div className="mb-10">
                <p className="text-16 text-purple font-medium mb-20">2. Is there anything specific we should know about your project ?</p>

                {/* <p className="text-14 text-black mb-5"></p> */}

                <div className="mb-10">
                  <Textarea
                    type="text"
                    plColor="#B2B2BF"
                    name="description"
                    resize="resize-none	"
                    bg="bg-white"
                    required={false}
                    rows={2}
                    placeholder="Background, requirements, budget, deadline, etc."
                    onChange={this.handleChange}
                  />
                </div>
              </div>

              <div className="mb-10">
                <p className="text-16 text-purple font-medium mb-10">3. Tell us how to contact you</p>

                <p className="text-14 text-black mb-5">Your Name*</p>

                <div className="mb-10">
                  <Input type="text" name="name" bg="bg-white" required={true} onChange={this.handleChange} />
                </div>

                <div className="grid grid-cols-2 gap-10">
                  <div>
                    <p className="text-14 text-black mb-5">Your Email*</p>

                    <div className="mb-10">
                      <Input type="text" name="email" bg="bg-white" required={true} onChange={this.handleChange} />
                    </div>
                  </div>

                  <div>
                    <p className="text-14 text-black mb-5">Your Phone Number</p>

                    <div className="mb-10">
                      <Input type="text" name="number" bg="bg-white" required={false} onChange={this.handleChange} />
                    </div>
                  </div>
                </div>
                <div className=" flex flex-wrap">
                  <div className="w-full md:w-half-auto">
                    <p className="text-14 text-black mb-5">What’s the best way to contact you?</p>

                    <div className="flex flex-row my-10">
                      <div className="form-group mr-10">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('contact-via', 'Email')}
                            type="radio"
                            name="contact-via"
                            value="Email"
                          />
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                          Email
                        </label>
                      </div>

                      <div className="form-group mr-10">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('contact-via', 'Phone')}
                            type="radio"
                            name="contact-via"
                            value="Phone"
                          />
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                          Phone
                        </label>
                      </div>

                      <div className="form-group mr-10">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('contact-via', 'Both')}
                            type="radio"
                            name="contact-via"
                            value="Both"
                          />
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                          Both
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="w-full md:w-half-auto ">
                    <p className="text-14 text-black mb-5">NDA needed</p>

                    <div className="flex flex-row my-10">
                      <div className="form-group mr-10">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => {
                              if (this.state.nda == 'No') this.handleChange('nda', 'Yes');
                              else this.handleChange('nda', 'No');
                            }}
                            type="checkbox"
                            name="nda"
                          />
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                          Yes
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row my-10">
                  <ReCAPTCHA sitekey={NEXT_PUBLIC_RECAPTCHA_SITE_KEY} size={'normal'} ref={this.reRef} />
                </div>
              </div>

              <input type="hidden" name="country" value={this.props.country} />

              <div className="col-span-2">
                <button
                  id="offer-submit"
                  type="submit"
                  className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </>
    );
  }
}
export default Offer;
